import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const stackLayoutDefaultVariants = {
  "gap": "md",
  "align": "stretch",
  "skeleton": false
}
const stackLayoutCompoundVariants = []

const stackLayoutSlotNames = [
  [
    "root",
    "stack-layout__root"
  ]
]
const stackLayoutSlotFns = /* @__PURE__ */ stackLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, stackLayoutDefaultVariants, getSlotCompoundVariant(stackLayoutCompoundVariants, slotName))])

const stackLayoutFn = memo((props = {}) => {
  return Object.fromEntries(stackLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const stackLayoutVariantKeys = [
  "gap",
  "align",
  "skeleton"
]
const getVariantProps = (variants) => ({ ...stackLayoutDefaultVariants, ...compact(variants) })

export const stackLayout = /* @__PURE__ */ Object.assign(stackLayoutFn, {
  __recipe__: false,
  __name__: 'stackLayout',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: stackLayoutVariantKeys,
  variantMap: {
  "gap": [
    "none",
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "align": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "skeleton": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, stackLayoutVariantKeys)
  },
  getVariantProps
})